/// <amd-module name="Wit/MarkdownEditorReduxAdapter/Redux/MarkdownEditorActions" />
import { ActionsUnion, createAction } from "redux/Utils/ActionHelper";
import { IMarkdownEditorKey } from "Wit/MarkdownEditorReduxAdapter/Redux/MarkdownEditorContracts";

export interface ICreateAttachmentSucceededParams {
    url: string;
    isImage: boolean;
    fileName: string;
}

export const enum MarkdownActionTypes {
    TextChanged = "Markdown/TextChanged",
    SaveValue = "Markdown/SaveValue",
    CreateAttachmentRequested = "Markdown/CreateAttachmentRequested",
    CreateAttachmentSucceeded = "Markdown/CreateAttachmentSucceeded",
    CreateAttachmentFailed = "Markdown/CreateAttachmentFailed",
    InitializeMarkdown = "Markdown/InitializeMarkdown",
    DisposeMarkdown = "Markdown/DisposeMarkdown",
    PreviewRequested = "Markdown/PreviewRequested",
    SetPreview = "Markdown/SetPreview",
    ResetPreviewState = "Markdown/ResetPreviewState",
    PreviewLoadError = "Markdown/PreviewLoadError"
}

export const MarkdownActions = {
    textChanged: (key: IMarkdownEditorKey, newText: string) => createAction(MarkdownActionTypes.TextChanged, { key, newText }),
    saveValue: (key: IMarkdownEditorKey) => createAction(MarkdownActionTypes.SaveValue, key),
    createAttachmentRequested: (key: IMarkdownEditorKey, files: File[], selectionStart: number, selectionEnd: number) =>
        createAction(MarkdownActionTypes.CreateAttachmentRequested, {
            key,
            files,
            selectionStart,
            selectionEnd
        }),
    createAttachmentSucceeded: (key: IMarkdownEditorKey, paramsList: ICreateAttachmentSucceededParams[], selectionStart: number, selectionEnd: number) =>
        createAction(MarkdownActionTypes.CreateAttachmentSucceeded, { key, paramsList, selectionStart, selectionEnd }),
    createAttachmentFailed: (key: IMarkdownEditorKey, error: string) => createAction(MarkdownActionTypes.CreateAttachmentFailed, { key, error }),
    initializeMarkdown: (key: IMarkdownEditorKey, initialValue?: string) => createAction(MarkdownActionTypes.InitializeMarkdown, { key, initialValue }),
    disposeMarkdown: (key: IMarkdownEditorKey) => createAction(MarkdownActionTypes.DisposeMarkdown, key),
    previewRequested: (key: IMarkdownEditorKey, previewValue: string) => createAction(MarkdownActionTypes.PreviewRequested, { key, previewValue }),
    setPreview: (key: IMarkdownEditorKey, previewHTML: string) => createAction(MarkdownActionTypes.SetPreview, { key, previewHTML }),
    resetPreviewState: (key: IMarkdownEditorKey) => createAction(MarkdownActionTypes.ResetPreviewState, key),
    previewLoadError: (key: IMarkdownEditorKey) => createAction(MarkdownActionTypes.PreviewLoadError, key)
};

export type MarkdownActions = ActionsUnion<typeof MarkdownActions>;
